import { XtLocale } from "@xt/xtbase";

/** Zendesk Help Center — 顶栏 Help 菜单与 Footer 共用 */
export function getHelpCenterLink() {
  return `https://spikex.zendesk.com/hc/${XtLocale.getZenLan()}`;
}
